// src/admin/components/LinkClickChart.js
import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

export default function LinkClickChart({ data }) {
  const transformed = data.map(click => ({
    date: new Date(click.clicked_at).toLocaleDateString('vi-VN'),
    count: 1
  }));

  const summary = Object.values(transformed.reduce((acc, item) => {
    acc[item.date] = acc[item.date] || { date: item.date, count: 0 };
    acc[item.date].count += 1;
    return acc;
  }, {}));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={summary}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Line type="monotone" dataKey="count" stroke="#6366f1" strokeWidth={3} dot={{ r: 4 }} />
      </LineChart>
    </ResponsiveContainer>
  );
}
